var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNolicense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58333 10.6667L8.25 9M8.25 9L9.91667 7.33333M8.25 9L6.58333 7.33333M8.25 9L9.91667 10.6667M15.75 9C15.75 13.1421 12.3921 16.5 8.25 16.5C4.10786 16.5 0.75 13.1421 0.75 9C0.75 4.85786 4.10786 1.5 8.25 1.5C12.3921 1.5 15.75 4.85786 15.75 9Z",
    stroke: "#7D8BA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNolicense);
export default __webpack_public_path__ + "static/media/nolicense.9f4c6209bbd6bc05fea5b5e699fcaa0f.svg";
export { ForwardRef as ReactComponent };